import { render, staticRenderFns } from "./CarouselMini.vue?vue&type=template&id=c81a31a0&"
import script from "./CarouselMini.vue?vue&type=script&lang=js&"
export * from "./CarouselMini.vue?vue&type=script&lang=js&"
import style0 from "./CarouselMini.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports